import { Component, OnInit, ViewChild } from '@angular/core';
import { faPencilAlt, faPlus, faTrash } from '@fortawesome/free-solid-svg-icons';
import * as firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import 'firebase/storage';
import * as moment from 'moment';

@Component({
  selector: 'app-store',
  templateUrl: './store.component.html',
  styleUrls: ['./store.component.css']
})
export class StoreComponent implements OnInit {

  @ViewChild('openingHours') openingHours;
  @ViewChild('turnModal') turnModal;

  faPencilAlt = faPencilAlt;
  faPlus = faPlus;
  faTrash = faTrash;

  db = firebase.firestore();
  currentUser = firebase.auth().currentUser;
  storage = firebase.storage();
  payment;
  logo: any = {};

  store: any = {
    name: '',
    deliveryPrice: '',
    phone: '',
    image_url: ''
  }

  turns = [];

  model: any = {};

  openingHour: any = {};
  currentOpeningHour: any = {};

  days = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
  dias = ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'];

  constructor() {
    this.getStore();
  }

  ngOnInit() { }

  getStore() {
    this.db.collection('store').doc(this.currentUser.uid).get().then(snapshot => {
      this.store = snapshot.data();
      this.logo.preview = this.store.image_url;
    }, e => {
      console.log(e);
    });
  }

  getTurn(day) {
    this.turns = [];
    this.db.collection('openingHour').doc(this.currentUser.uid).collection(day).get().then(snapshot => {
      snapshot.forEach(s => {
        this.turns.push({
          id: s.id,
          name: s.data().name,
          open: s.data().open,
          close: s.data().close
        });
      });
      this.openingHours.show();
    }, e => {
      console.log(e);
    });
  }

  imageChange(e) {
    let file = e.target.files[0];
    this.storage.ref().child(this.currentUser.uid).child('logo.' + file.type.split('/')[1]).put(file).then(r => {
      r.ref.getDownloadURL().then(url => {
        this.store.image_url = url;
        this.db.collection('store').doc(this.currentUser.uid).update({ image_url: url });
      });
    }, e => {
      console.log(e);
    });
  }

  selectImage(event, logo) {
    if (!event.target || event.target.files.length < 1) {
      return;
    }

    let fileReader = new FileReader();
    const [file] = event.target.files;
    logo.type = file.type.split('/')[1];
    logo.filetype = file.type;
    
    fileReader.readAsArrayBuffer(file);

    fileReader.onload = (file: any) => {      
      logo.preview = 'data:' + logo.filetype + ';base64,' + this.encode(new Uint8Array(file.target.result));
      logo.image =  new Uint8Array(file.target.result);
      logo.change = true;      
    }
  }

  saveStore() {
    if (this.store.name.length < 2) {
      return alert('O Nome do estabelecimento deve ter pelo menos 2 caracteres');
    }
    if (this.store.deliveryPrice < 0) {
      return alert('Insira uma taxa de entrega correta (0 para grátis)');
    }
    this.db.collection('store').doc(this.currentUser.uid).update(this.store).then(r => {
      if (this.logo.change) {
        this.storage.ref().child(this.currentUser.uid).child('logo.' + this.logo.type.split('/')[1]).put(this.logo.image).then(r => {
          r.ref.getDownloadURL().then(url => {
            this.store.image_url = url;
            this.db.collection('store').doc(this.currentUser.uid).update({ image_url: url });
            alert('Salvo com sucesso');
          });
        }, e => {
          console.log(e);
        });
      } else {
        alert('Salvo com sucesso');
      }
    }, e => {
      console.log(e);
      alert(e);
    });
  }

  editOpeningHour(day) {
    this.currentOpeningHour.day = this.days[day];
    this.currentOpeningHour.dia = this.dias[day];
    this.getTurn(this.currentOpeningHour.day);
  }

  newTurn() {
    this.model = {};
    this.turnModal.show();
  }

  createTurn() {
    if (!this.model.name || !this.model.open || !this.model.close) {
      return alert('Insira os dados corretamente');
    }
    if (this.model.name.length < 2) {
      return alert('O nome deve ter pelo menos 2 caracteres');
    }
    if (this.model.open.length != 5) {
      return alert('Insira um horário correto');
    }
    if (this.model.close.length != 5) {
      return alert('Insira um horário correto');
    }
    if (moment(this.model.open, 'HH:mm').isAfter(moment(this.model.close, 'HH:mm'))) {
      return alert('O horário de abertura deve ser antes do horário de fechamento');
    }
    this.db.collection('openingHour').doc(this.currentUser.uid).collection(this.currentOpeningHour.day).add({
      name: this.model.name,
      open: this.model.open,
      close: this.model.close
    }).then(r => {
      this.turnModal.hide();
      this.getTurn(this.currentOpeningHour.day);
    }, error => {
      console.log(error);
    });
  }

  deleteTurn(id) {
    this.db.collection('openingHour').doc(this.currentUser.uid).collection(this.currentOpeningHour.day).doc(id).delete().then(() => {
      this.getTurn(this.currentOpeningHour.day);
    }, e => {
      console.log(e);
    });
  }

  addPayment() {
    if (!this.payment || this.payment == '') {
      return;
    }
    if (this.store.payments) {
      this.store.payments.push(this.payment);
    } else {
      this.store.payments = [this.payment];
    }
    this.payment = '';
  }

  removePayment(index) {
    this.store.payments.splice(index, 1);
  }

  encode (input) {
    let keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
    let output = "";
    let chr1, chr2, chr3, enc1, enc2, enc3, enc4;
    let i = 0;

    while (i < input.length) {
        chr1 = input[i++];
        chr2 = i < input.length ? input[i++] : Number.NaN;
        chr3 = i < input.length ? input[i++] : Number.NaN;

        enc1 = chr1 >> 2;
        enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
        enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
        enc4 = chr3 & 63;

        if (isNaN(chr2)) {
            enc3 = enc4 = 64;
        } else if (isNaN(chr3)) {
            enc4 = 64;
        }
        output += keyStr.charAt(enc1) + keyStr.charAt(enc2) + keyStr.charAt(enc3) + keyStr.charAt(enc4);
    }
    return output;
  }

}
